<ng-container *transloco="let t; read: 'providers'">
  <app-grid-page [title]="t('title')">
    <app-grid
      [columns]="columns()"
      [data]="providers()"
      [rowId]="providerId"
      [loading]="isLoading()"
      [page]="page()"
      [pageSize]="size()"
      [totalElements]="totalElements()"
      [totalPages]="totalPages()"
      [sort]="sort()"
      [rowActions]="rowActions()"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (rowActionClick)="onRowAction($event.actionId, asProvider($event.row))"
      (rowDblClick)="onRowDblClick(asProvider($event))"
    ></app-grid>
  </app-grid-page>
</ng-container>
